
import templatePage from '@/app-template/lib/pages/NotificationListPage.vue';
export default {
  components: { templatePage },
};
